import {defineStore} from "pinia";
import {computed, ref, watch} from "vue";
import * as CmsService from "@/services/cms.service";
import type { Page } from "@/models/Page";
import {useLocalization} from "@/locales/localization";

export const usePageStore = defineStore('pages', () => {

    const { currentLocale } = useLocalization();


    const loading = ref(false);
    const firstPage = ref<Partial<Page>>({
        imageSet: {
            '380w': false
        }
    });

    const pageList = ref<Page[]>([]);
    const pages = ref<number>(1);
    const currentPage = ref<number>(1);

    const hasPages = computed(() => {
      return Boolean(firstPage.value) || (pageList.value && pageList.value.length > 0);
    });

    async function getAll(slug: string, page = 1, size = 10, sites = 'cosmosy',  options?: { splitHero?: boolean }) {
      loading.value = true;
      try {
          const { data } = await CmsService.getChildren(slug, { page, size, sites }, currentLocale.value);
          const payload = data ?? {};
          const results: Page[] = payload.results ?? [];

          const splitHero = options?.splitHero ?? true;
          if (splitHero) {
              firstPage.value = results[0];
              pageList.value = results.slice(1);
          } else {
              firstPage.value = undefined as unknown as Page;
              pageList.value = results;
          }

          pages.value = Number(payload.pages ?? 1);
          currentPage.value = Number(payload.currentPage ?? page);
      } catch (e) {
          console.error('Failed to fetch pages', e);
          firstPage.value = {};
          pageList.value = [];
          pages.value = 1;
          currentPage.value = 1;
      } finally {
          loading.value = false;
      }
    }

    watch(currentLocale, (newLocale, oldLocale) => {
        if (newLocale !== oldLocale) {
            getAll('travel-inspiration', currentPage.value, 10);
        }
    });

    function getPage(slug: string) {
        return CmsService.getPageContents(slug, "en", currentLocale.value)
    }

    return { loading, firstPage, pageList, pages, currentPage, hasPages, getAll, getPage }

});